<template>
  <div class="search-bar">
    <input
      type="text"
      v-model="searchQuery"
      placeholder="Start typing an artist or avatar name..."
      @input="onInput"
    />
    <button v-if="searchQuery" @click="clearSearch" class="clear-button">
      <span>X</span>
    </button>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'SearchBar',
  data() {
    return {
      searchQuery: '',
    };
  },
  created() {
    this.debouncedSearch = debounce(this.onSearch, 300);
  },
  methods: {
    onInput() {
      this.debouncedSearch();
    },
    onSearch() {
      this.$emit('search', this.searchQuery.trim());
    },
    clearSearch() {
      this.searchQuery = '';
      this.$emit('search', this.searchQuery);
    },
  },
};
</script>

<style scoped>
.search-bar {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

input[type="text"] {
  padding: 10px 40px 10px 15px;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 25px;
  font-size: 16px;
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: #ff4500;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.clear-button span {
  color: white;
  font-size: 14px;
  font-weight: bold;
}
</style>
